import { ContractHashChipRewards } from '~/blockchain/contract';
import { ethersWeb3Provider, providerOAS } from '~/blockchain/oas';
import configs from '~/configs'
import { changeNetworkInMetamask } from '~/blockchain/metamask'
import { ethers } from 'ethers'

export const callClaimReward = async (tokenId, rank, sdk) => {
  let signer;
  try {
    if (localStorage.getItem('wallet') === 'OAS') {
      signer = ethersWeb3Provider.getSigner(providerOAS.accounts[0])
    } else {
      await sdk.connect()
      await changeNetworkInMetamask(sdk.getProvider(), configs.NETWORK.chainId)
      const web3Provider = new ethers.providers.Web3Provider(sdk.getProvider())
      signer = web3Provider.getSigner()
    }
    console.log(signer.getAddress());
    console.log(signer.getBalance())

    const contract = ContractHashChipRewards.connect(signer);
    const tx = await contract.claimReward(tokenId, rank);
    console.log("Transaction sent, hash:", tx.hash);
    const receipt = await tx.wait();
    console.log("Transaction confirmed:", receipt.transactionHash);

    return { success: true, txHash: receipt.transactionHash };
  } catch (error) {
    console.error("Error claiming reward:", error);
    const errorMessage = error.reason || error.message || 'Unknown error'
    throw new Error(errorMessage);
  }
};
